import { useEffect, useState, type FormEvent } from 'react';
import { errorText } from '../api';
import { adminApi, type Brand } from './api';
import { Link, navigate } from './app';

/** Liste der Auftritte mit ihren Terminarten. Ein Auftritt je Marke (Konzept 1). */
export function BrandListPage() {
  const [brands, setBrands] = useState<Brand[] | null>(null);
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminApi
      .listBrands()
      .then((r) => setBrands(r.brands))
      .catch((e) => setError(errorText(e)));
  }, []);

  async function create(event: FormEvent) {
    event.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    setError(null);
    try {
      const { id } = await adminApi.createBrand(name.trim());
      navigate(`/admin/auftritte/${id}`);
    } catch (e) {
      setError(errorText(e));
      setBusy(false);
    }
  }

  return (
    <>
      <div className="admin-head">
        <div>
          <h1>Auftritte</h1>
          <p className="muted">Je Marke ein Auftritt: eigener Name, eigenes Logo, eigene Farbe, eigene Buchungsseite.</p>
        </div>
      </div>
      <form className="card admin-create" onSubmit={create}>
        <div className="field" style={{ flexGrow: 1 }}>
          <label htmlFor="new-brand">Neuer Auftritt</label>
          <input id="new-brand" type="text" placeholder="z. B. PraxiPet" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <button type="submit" className="button" disabled={busy || !name.trim()}>
          Anlegen
        </button>
        {error && <div className="error-inline">{error}</div>}
      </form>
      {brands === null && !error && <p className="muted">Lade …</p>}
      {brands?.length === 0 && <p className="muted">Noch kein Auftritt. Leg oben den ersten an – zum Beispiel für PraxiPet.</p>}
      <div className="stack">
        {brands?.map((b) => (
          <div key={b.id} className="card">
            <div className="card__head">
              <div className="brand-row">
                <span className="swatch" style={{ background: b.brandColor ?? 'var(--border)' }} />
                <div>
                  <Link href={`/admin/auftritte/${b.id}`} className="card__title">
                    {b.name}
                  </Link>
                  <p className="muted small">
                    Buchungsseite: <a href={`/${b.slug}`}>/{b.slug}</a>
                  </p>
                </div>
              </div>
              <Link href={`/admin/auftritte/${b.id}`} className="button button--secondary button--small">
                Bearbeiten
              </Link>
            </div>
            {b.eventTypes.length === 0 ? (
              <p className="muted small">Noch keine Terminart.</p>
            ) : (
              <ul className="plain-list">
                {b.eventTypes.map((t) => (
                  <li key={t.id}>
                    <span className={t.active ? '' : 'muted'}>{t.title}</span> <span className="faint small">· {t.durationMinutes} Min.{t.active ? '' : ' · nicht buchbar'}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
